// eslint-disable-next-line no-unused-vars
import { get, post, put, remove } from './config'

export const isRefresh = true

/**
 * 用户登录
 * @param {*} data
 */
export const login = (data) => post(`/api/v1/auth/login`, data)

/**
 * 退出登录
 * @param {*} data
 */
export const logout = (data) => get(`/api/v1/user/signout`, data)

/**
 * 用户注册
 * @param {*} data
 */
export const register = (data) => post(`/api/v1/auth/register`, data)

/**
 * 获取图片验证码
 * @param {*} data
 */
export const getImageCaptcha = (data) => get(`/api/v1/auth/captcha`, data)

/**
 * 发送短信
 * @param {*} data
 */
export const sendSms = (data) => post(`/api/v1/sms/code/send`, data)

/**
 * 使用微信登录后补全信息，绑定账号
 * @param {*} data
 */
export const bindAccount = (data) => post(`/api/v1/auth/bind`, data)

/**
 * 修改密码
 * @param {*} data
 */
export const changePassword = (data) => post(`/api/v1/auth/changePassword`, data)

/**
 * 获取学科列表
 * @param {*} data
 */
export const getMajorList = () => get(`/api/v1/journal/subject`)

/**
 * 根据搜索条件分页获取期刊列表
 * @param {*} data
 */
export const getJournalList = (data) => get(`/api/v1/journal/search`, data)

/**
 * Jane搜索期刊信息
 * @param {*} data
 */
export const getJaneSearch = (journalId) => get(`/api/v1/journal/jane_search?title=${journalId}`)
/**
 * 获取期刊详情
 * @param {*} journalId
 * @param {*} data
 */
export const getJournalInfo = (journalIssn, data) => get(`/api/v1/journal/${journalIssn}/details`, data)

/**
 * 获取期刊下评论列表
 * @param {*} journalId
 * @param {*} data
 */
export const getJournalComments = (journalIssn, data) => get(`/api/v1/journal/${journalIssn}/comment`, data)

/**
 * 获取用户信息
 * @param {*} data
 */
export const getUserInfo = (data) => get(`/api/v1/user/info`, data)

/**
 * 更新用户信息
 * @param {*} data
 */
export const updateUserInfo = (data) => put(`/api/v1/user/info`, data)

/**
 * 获取用户关注的期刊列表
 * @param {*} data
 */
export const getUserFollowList = (data) => get(`/api/v1/user/journal/favorite`, data)

/**
 * 关注期刊
 * @param {*} journalId
 * @param {*} data
 */
export const followJournal = (journalId, data) => post(`/api/v1/user/journal/${journalId}/favorite`, data)

/**
 * 取消关注期刊
 * @param {*} journalId
 * @param {*} data
 */
export const unfollowJournal = (journalId, data) => remove(`/api/v1/user/journal/${journalId}/favorite`, data)

/**
 * 获取用户评论列表
 * @param {*} data
 */
export const getUserCommentList = (data) => get(`/api/v1/user/journal/comment`, data)

/**
 * 添加期刊评论
 * @param {*} journalId
 * @param {*} data
 */
export const addComment = (journalId, data) => post(`/api/v1/user/journal/${journalId}/comment`, data)

/**
 * 更新评论的点赞状态
 * @param {*} id
 * @param {*} data
 */
export const updateCommentLikeStatus = (id, data) => post(`/api/v1/user/journal/comment/${id}/like`, data)

/**
 * 删除期刊评论
 * @param {*} commentId
 * @param {*} data
 */
export const deleteComment = (commentId, data) => remove(`/api/v1/user/journal/${commentId}/comment`, data)

/* 期刊指南 */
/**
 * 获取期刊指南列表
 * @param {*} data
 */
export const getList = (data) => get(`/api/v1/web_content/list`, data)

/**
 * 获取期刊指南详情
 * @param {*} data
 */
export const getListDetails = (id, data) => get(`/api/v1/web_content/${id}`, data)

/**
 * 获取单独公告
 * @param {*} type
 */
export const getNotice = (type) => get(`/api/v1/web_content/${type}/getOne`)

/* 1.5 start */

/**
 * 获取登录微信公众号二维码信息
 */
export const getLoginQrcode = () => get(`/api/v1/auth/official/qrcode/login`)

/**
 * 获取绑定微信公众号二维码信息
 */
export const getBindQrcode = () => get(`/api/v1/auth/official/qrcode/bind`)

/**
 * 微信公众号二维码登录轮询接口微信公众号二维码登录轮询接口
 * @param {*} scene 获取二维码得到的唯一标识
 */
export const askLogin = (scene) => get(`/api/v1/auth/official/qrcode/${scene}/ask/login`)

/**
 * 微信公众号二维码绑定轮询接口
 * @param {*} scene
 */
export const askBind = (scene) => get(`/api/v1/auth/official/qrcode/${scene}/ask/bind`)

/**
 * 微信扫码登录后绑定手机号
 * 绑定手机号
 * @param {*} data
 */
export const bindMobile = (data) => post(`/api/v1/auth/official/bind/mobile`, data)

/**
 * 【2020-08-18】根据期刊名称查看期刊是否存在
 * @param {*} data
 */
export const getJournalId = (data) => get(`/api/v1/journal/exists`, data)

/* 1.5 end */

// 获取banner
export const getBanner = (data) => get(`/api/v1/web/basicdata/carouselinfo/list`, data, 'java')

/*
 * 查询首页横幅列表
 */
export const getBannerInfo = (data) => get(`/api/v1/web/basicdata/bannerinfo/detail`, data, 'java')
/*
 * 查询首页弹窗
 */
export const getPopupWindowInfo = (data) => get(`/api/v1/web/basicdata/popupwindowinfo/detail`, data, 'java')
/*
 * 查询首页折叠广告
 */
export const getCollapseAdInfo = (data) => get(`/api/v1/web/basicdata/autobannerinfo/detail`, data, 'java')
/*
 * 查询期刊年发文量
 */
export const getPublicationCountOfJournal = (data) => get(`/api/v1/web/data/publication/detail`, data, 'java')



// WEBPACK FOOTER //
// ./src/api/index.js